import * as core from '../../../../../../../core'
import * as employeePlanning from '../employee-planning'

export const RESOURCE = {
  payload: {
    alias: 'projects',
    appAlias: employeePlanning.RESOURCE.payload.alias,
    description: "Explore an organization's projects.",
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Projects',
    page: { alias: 'projects' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
